// Module-level memory — survives service lifetimes but not a page reload.
// Keeps the raw ID token out of sessionStorage (XSS-accessible) while still
// letting ApiClientService read it without injecting AuthService (circular dep).
let _memToken: string | null = null;
let _memExpiresAt: number | null = null;

export function setMemToken(token: string | null, expiresAt?: number): void {
  // Module-level state is shared across SSR requests — only write in the browser.
  if (typeof window === 'undefined') return;
  _memToken = token;
  _memExpiresAt = token !== null ? (expiresAt ?? null) : null;
}

export function readStoredToken(): string | null {
  if (typeof window === 'undefined') return null;
  if (_memToken === null) return null;
  if (_memExpiresAt !== null && Date.now() >= _memExpiresAt) return null;
  return _memToken;
}
